import { ArrowLeft } from '@phosphor-icons/react';
import { REDIRECT_TO_STRIPE_TIMESTAMP, SVG_SIZE_M } from 'src/constants';
import { GTMEvent } from 'src/types';
import { initializeGTMDeferred, sendGTMEvent } from 'src/utils';
import { Button } from 'src/v2/commonComponents/Button';
import styles from './PaymentGoBackButton.module.scss';
import { env } from 'src/env';

export const PaymentGoBackButton = () => {
  const handleRemoveFlagFromLS = () => {
    if (!!localStorage.getItem(REDIRECT_TO_STRIPE_TIMESTAMP)) {
      localStorage.removeItem(REDIRECT_TO_STRIPE_TIMESTAMP);
    }
  };

  const handleBackButtonClick = () => {
    initializeGTMDeferred();
    sendGTMEvent(GTMEvent.PAYMENT_BACK_BUTTON_CLICK);
    handleRemoveFlagFromLS();
    window.location.href = env.REACT_APP_SUPER_NINJA_URL;
  };

  return (
    <Button
      color="transparent"
      size="small"
      shape="round"
      className={styles.goBackLink}
      onClick={handleBackButtonClick}
    >
      <ArrowLeft size={SVG_SIZE_M} />
    </Button>
  );
};
